import { createSelector } from 'reselect'

/** A Redux selector to retrieve communications
 * @param state - The Redux state
 * @param {Array} [] - The communications to fetch
 */

const getSummary = (state: any) => state.feedbackSummary

/** A Redux selector to retrieve Feedbacks count
 * @param state - The Redux state
 * @param {Number} - Numerical value indicating feedbacks count.
 */

export const selectFeedbackCount = createSelector(
  getSummary,
  (data) => data && data.feedBackCount ? data.feedBackCount : 0
)

/** A Redux selector to retrieve Total Feedbacks
 * @param state - The Redux state
 * @param {Number} - Numerical value indicating total feedbacks.
 */

export const selectTotalFeedbackCount = createSelector(
  getSummary,
  (data) =>  data && data.feedback && data.feedback && data.feedback.total ?  data.feedback.total : 0
)

/** A Redux selector to retrieve Average rating
 * @param state - The Redux state
 * @param {Number} - Numerical value indicating Average rating.
 */

export const selectAverageRating = createSelector(
  getSummary,
  (data) => data && data.averageRating ? data.averageRating : 0.0
)

/** A Redux selector to retrieve Feedbacks data
 * @param state - The Redux state
 * @param {Array} - Array value containing feedbacks data.
 */

export const selectFeedbackData = createSelector(
  getSummary,
  (data) => data && data.feedback && data.feedback.feedback ? data.feedback.feedback : []
)

/** A Redux selector to retrieve Feedbacks data isLoading state
 * @param state - The Redux state
 * @param {Boolean} - Boolean value indicating feedbacks data isLoading state.
 */

export const selectFeedbackDataIsLoading = createSelector(
  getSummary,
  (data) => data && data.feedback ? data.feedback.status.inProgress : false
)
